/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Users_Form_Group_Partner_DescriptionInputs */

const en_users_form_group_partner_description = /** @type {(inputs: Users_Form_Group_Partner_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Partners who receive commissions and manage custom banking information.`)
};

const pt_br2_users_form_group_partner_description = /** @type {(inputs: Users_Form_Group_Partner_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Parceiros que recebem comissões e gerenciam informações bancárias personalizadas.`)
};

/**
* | output |
* | --- |
* | "Partners who receive commissions and manage custom banking information." |
*
* @param {Users_Form_Group_Partner_DescriptionInputs} inputs
* @param {{ locale?: "en" | "pt-BR" }} options
* @returns {LocalizedString}
*/
export const users_form_group_partner_description = /** @type {((inputs?: Users_Form_Group_Partner_DescriptionInputs, options?: { locale?: "en" | "pt-BR" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Users_Form_Group_Partner_DescriptionInputs, { locale?: "en" | "pt-BR" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_users_form_group_partner_description(inputs)
	return pt_br2_users_form_group_partner_description(inputs)
});